<template>
  <v-container>
    <!-- customerId:{{ customerId }} priceId:{{ priceId }} -->
    <v-alert
      timeout="6000"
      dense
      dismissible
      v-if="successMessage != ''"
      type="success"
    >
      {{ successMessage }}
    </v-alert>
    <v-alert
      dismissible
      dense
      v-if="errorMessage != '' && errorMessage"
      type="error"
    >
      {{ errorMessage }}
    </v-alert>

    <v-row justify="center" align="center">
      <v-col cols="12"
        ><h1 justify="center" align="center">
          {{ companyName }}
        </h1></v-col
      >
      <v-col cols="12"
        ><h2 justify="center" align="center">
          {{ packageName }}
        </h2></v-col
      >

      <v-col cols="12" md="6">
        <v-card flat class="pa-4">
          <v-form ref="form" @submit.prevent="handleSubmit">
            <v-text-field
              label="Card Holder Name"
              v-model="cardHolderName"
              :rules="[rules.required]"
            ></v-text-field>
            <v-select
              v-model="billingInterval"
              v-if="priceModel || priceId"
              :items="intervals"
              label="Billing Interval"
            ></v-select>
            <v-text-field
              label="Amount"
              v-model="amount"
              :rules="[rules.required, rules.number]"
              :readonly="priceModel || priceId"
              type="number"
            ></v-text-field>
            <div id="card-element" class="my-4"></div>
            <!-- <v-checkbox
              label="Save card for future payments"
              v-model="saveCard"
            ></v-checkbox> -->
            <v-btn :loading="loading" color="primary" type="submit">{{
              submitCaption || caption || "Submit Payment"
            }}</v-btn>
            <v-alert v-if="error" type="error">{{ error }}</v-alert>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import * as fun from "../plugins/common";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
export default {
  props: {
    billingAmount: Number,
    priceModel: Object,
    itemDescription: String,
    submitCaption: String,
  },
  data() {
    return {
      stripe: null,
      card: null,
      cardHolderName: "",
      error: null,
      saveCard: false,
      amount: 0,
      priceId: "",
      customerId: "",
      caption: "",

      rules: {
        required: (value) => !!value || "Required.",
        number: (value) => !isNaN(value) || "Must be a number.",
      },
      intervals: ["monthly", "quarterly", "semiannually", "annually"],
      packageModel: null,
      billingInterval: "",
      packageName: "",
      companyName: "",
      loading: false,
      successMessage: "",
      errorMessage: "",
    };
  },
  async mounted() {
    var that = this;
    var id = this.$router.currentRoute.params.id;
    if (id) {
      this.customerId = id.split("-")[0];
      this.priceId = id.split("-")[1];

      if (this.priceId) {
        this.caption = "Subscribe";
        var data = {
          object_name: "moverai_package",
          qry: {
            stripe_product_id: this.priceId,
          },
          additional_data: [
            {
              obj_name: "my_customers",
              qry: { _id: this.customerId },
            },
          ],
        };
        axios
          .post(that.serverURL + "/get_data", data, {
            withCredentials: true,
          })
          .then((response) => {
            this.packageModel = response.data.model[0];
            this.companyName =
              response.data.additional_model.my_customers[0].contact.company;
            if (this.packageModel) {
              this.packageName = "Package: " + this.packageModel.package_name;
              this.intervals = [];
              if (this.packageModel.monthly) {
                this.intervals.push("monthly");
              }
              if (this.packageModel.quarterly) {
                this.intervals.push("quarterly");
              }
              if (this.packageModel.semiannually) {
                this.intervals.push("semiannually");
              }
              if (this.packageModel.annually) {
                this.intervals.push("annually");
              }
              this.billingInterval = this.intervals[0];
              this.amount = this.packageModel[this.billingInterval];
            }
          });
      }
      // this.packageId = id.split("__")[1];
    }

    const pKey =
      "pk_live_51OsSpk04kpeqHnoBIRU3eJqiZJP8cMAQyomR8XFiPXhNsKSr6fcNQ6ahDtX763ZLpdcBk1R7RxsYZIoPAq2MneJ500DtYHznOu";
    this.stripe = await loadStripe(pKey);
    // if (this.priceModel) {
    //   var updated = await this.syncProducts();
    // }

    const elements = this.stripe.elements();
    this.card = elements.create("card");
    this.card.mount("#card-element");
    this.card.on("change", (event) => {
      if (event.error) {
        this.error = event.error.message;
      } else {
        this.error = null;
      }
    });
    if (that.priceModel) {
      that.billingInterval = "monthly";
      that.amount = that.priceModel["total_" + that.billingInterval];
    }
  },
  methods: {
    async setupCard() {
      // Create a setup intent on the backend
      var that = this;
      const response = await fetch(this.serverURL + "/create_setup_intent", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const { client_secret } = await response.json();
      // Confirm the card setup
      const { setupIntent, error } = await this.stripe.confirmCardSetup(
        client_secret,
        {
          payment_method: {
            card: that.card,
            billing_details: {
              name: that.cardHolderName,
            },
          },
        }
      );
      if (error) {
        this.loading = false;
        console.error(error);
        this.errorMessage = error.message;
      } else {
        // Send the setup intent ID and amount to the backend to charge the card
        const chargeResponse = await fetch(
          this.serverURL + "/charge_stripe_card",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              setup_intent_id: setupIntent.id,
              amount: this.amount,
            }),
          }
        );

        const chargeResult = await chargeResponse.json();
        this.loading = false;
        console.log(chargeResult);
        this.successMessage = "Payment successful!";
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.errorMessage = "";
      this.successMessage = "";
      // if (this.saveCard) {
      const { token, error } = await this.stripe.createToken(this.card, {
        name: this.cardHolderName,
      });
      if (error) {
        this.error = error.message;
      } else {
        this.submitPayment(token);
      }
      // } else {
      //   this.setupCard();
      // }
    },

    async submitPayment(token) {
      this.error = null;
      this.errorMessage = "";
      try {
        const response = await fetch(this.serverURL + "/charge_stripe_card", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token: token.id,
            amount: this.amount,
            saveCard: this.saveCard,
            customerId: this.customerId,
            priceId: this.priceId,
          }),
        });
        const data = await response.json();
        this.loading = false;
        if (data.error) {
          // this.error = data.error;
          this.errorMessage = data.error;
        } else {
          this.successMessage = "Payment successful!";
        }
      } catch (error) {
        this.loading = false;
        this.error = "Payment failed. Please try again.";
      }
    },
  },
  watch: {
    billingInterval() {
      if (this.priceModel) {
        this.amount = this.priceModel["total_" + this.billingInterval];
      } else {
        this.amount = this.packageModel[this.billingInterval];
      }
    },
  },
};
</script>

<style scoped>
#card-element {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
}
</style>
